export const enum CommissionStatuses {
  Created = 'created', // Новая
  OnApproval = 'on_approval', // На согласовании
  Rejected = 'rejected', // Отклонена
  Approved = 'approved', // Согласована
  Cancelled = 'cancelled', // Аннулирована
  Implemented = 'implemented', // Внедрена
  Archived = 'archived', // Архив
  CreateChildAvailable = 'create_child_available',
}
